import React from "react";
import { Table, TableBody } from "@/components/ui/table";
import NotificationListHeader from "./NotificationListHeader";
import NotificationListItem from "./NotificationListItem";
import EmptyStateMessage from "./list/EmptyStateMessage";
import LoadingState from "./list/LoadingState";
import { SupabaseNotification } from "@/types/notifications";

interface NotificationTableProps {
  isLoading: boolean;
  notifications: SupabaseNotification[];
  displayedNotifications: SupabaseNotification[];
  viewMode: "active" | "archived";
  formatDate: (date: string) => string;
  sortConfig?: { key: string; direction: 'asc' | 'desc' };
  requestSort: (key: string) => void;
  handleNotificationClick: (id: string) => void;
  handleArchive: (e: React.MouseEvent, id: string) => void;
  handleRestore: (e: React.MouseEvent, id: string) => void;
  handleDelete: (e: React.MouseEvent, id: string) => void;
  handleSendWebhook?: (e: React.MouseEvent, id: string) => void;
  // Bulk selection props
  canUseBulkActions: boolean;
  isAllSelected: boolean;
  isPartiallySelected: boolean;
  toggleSelectAll: () => void;
  isSelected: (id: string) => boolean;
  toggleSelectItem: (id: string) => void;
}

const NotificationTable = ({
  isLoading,
  notifications,
  displayedNotifications,
  viewMode,
  formatDate,
  sortConfig,
  requestSort,
  handleNotificationClick,
  handleArchive,
  handleRestore,
  handleDelete,
  handleSendWebhook,
  canUseBulkActions,
  isAllSelected,
  isPartiallySelected,
  toggleSelectAll,
  isSelected,
  toggleSelectItem
}: NotificationTableProps) => {
  return (
    <div className="rounded-md border">
      <Table>
        <NotificationListHeader 
          onSort={requestSort}
          sortConfig={sortConfig}
          showBulkSelect={canUseBulkActions}
          isAllSelected={isAllSelected}
          isPartiallySelected={isPartiallySelected}
          onToggleSelectAll={toggleSelectAll}
        />
        <TableBody>
          {isLoading ? (
            <LoadingState />
          ) : (
            <EmptyStateMessage 
              viewMode={viewMode}
              hasNotifications={notifications.length > 0}
              hasFilteredResults={displayedNotifications.length > 0}
            />
          )}
          {displayedNotifications.map((notification) => (
            <NotificationListItem
              key={notification.id}
              notification={notification}
              formatDate={formatDate}
              onNotificationClick={handleNotificationClick}
              onArchive={handleArchive}
              onRestore={handleRestore}
              onDelete={handleDelete}
              onSendWebhook={handleSendWebhook}
              isArchived={viewMode === "archived"}
              showBulkSelect={canUseBulkActions}
              isSelected={isSelected(notification.id)}
              onToggleSelect={toggleSelectItem}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default NotificationTable;